import React from 'react';
import { Card } from './Card';
interface SettingsSectionProps {
  /** Section title */
  title: string;
  /** Section description */
  description?: string;
  /** Lucide icon component */
  icon: React.ElementType;
  /** Accent color classes: 'bg-{color}-100 text-{color}-600' */
  accentColor?: string;
  /** Optional right-side action (e.g. a button) */
  action?: React.ReactNode;
  /** Card content */
  children: React.ReactNode;
  /** Extra classes on the Card wrapper */
  className?: string;
}
export function SettingsSection({
  title,
  description,
  icon: Icon,
  accentColor = 'bg-indigo-100 text-indigo-600',
  action,
  children,
  className = ''
}: SettingsSectionProps) {
  const bgClass = accentColor.split(' ').find(c => c.startsWith('bg-')) || 'bg-indigo-100';
  const textClass = accentColor.split(' ').find(c => c.startsWith('text-')) || 'text-indigo-600';
  return <Card className={`p-6 ${className}`} data-id="element-2331">
      <div className="flex items-center justify-between mb-6" data-id="element-2332">
        <div className="flex items-center gap-3" data-id="element-2333">
          <div className={`w-10 h-10 rounded-full ${bgClass} flex items-center justify-center ${textClass}`} data-id="element-2334">
            <Icon className="w-5 h-5" data-id="element-2335" />
          </div>
          <div data-id="element-2336">
            <h3 className="text-lg font-bold text-slate-900" data-id="element-2337">{title}</h3>
            {description && <p className="text-sm text-slate-500" data-id="element-2338">{description}</p>}
          </div>
        </div>
        {action && <div className="flex-shrink-0" data-id="element-2339">{action}</div>}
      </div>
      {children}
    </Card>;
}